import { saveValue, SELECTED_UNIVERSITY_STORAGE_KEY, SELECTED_FACULTY_STORAGE_KEY } from "./generics";
import { mountUniversityPicker } from "./universityPicker";

// Strona kafelkowa (landing_tiles w views.py) - JEDEN szablon pod dwoma adresami: "/" (prawdziwa
// strona główna) i "/start/" (logo w nagłówku/"Zmień wydział" w menu, patrz base.html). Auto-
// przenoszenie na zapamiętany wydział (WYŁĄCZNIE na "/", nigdy na "/start/" - to jedyne miejsce,
// z którego da się jawnie zmienić wybór) dzieje się w blokującym, inline skrypcie w <head> (patrz
// landing3.html) - PRZED wyrenderowaniem tej strony, żeby user w ogóle nie zobaczył kafelków,
// które i tak zaraz znikną (zgłoszenie: "błyska przed okiem"). Ten plik zajmuje się już tylko
// zapisem wyboru przy kliknięciu w kafelek (żeby "/" następnym razem wiedziało, dokąd przenieść)
// - nie przechwytuje samego kliknięcia/nawigacji, tylko dopisuje zapis PRZED nią.

const container = document.getElementById("faculty-tiles");

if (container) {
    container.querySelectorAll<HTMLAnchorElement>(".faculty-tile").forEach(tile => {
        tile.addEventListener("click", () => {
            const { universitySlug, facultySlug } = tile.dataset;
            if (universitySlug && facultySlug) {
                saveValue(SELECTED_UNIVERSITY_STORAGE_KEY, universitySlug);
                saveValue(SELECTED_FACULTY_STORAGE_KEY, facultySlug);
            }
        });
    });
}

// "Wszystkie uczelnie i wydziały" pod kafelkami - pokazuje w miejscu ten sam picker co /inne/
// (patrz universityPicker.ts), bez przeładowania strony; kafelki się wtedy chowają, żeby picker
// był jedyną (wyśrodkowaną) rzeczą pod nagłówkiem. Bez przywracania zapamiętanej uczelni - skoro
// ktoś tu kliknął, to właśnie chce wybrać coś innego niż kafelek/poprzedni wybór. Picker budujemy
// raz (mountUniversityPicker dopina też globalny listener kliknięć) - kolejne otwarcia tylko go
// odkrywają.
const showAllButton = document.getElementById("show-all-faculties");
const backButton = document.getElementById("back-to-tiles");
const pickerContainer = document.getElementById("landing-container");
const tagline = document.getElementById("landing-tagline");

if (container && showAllButton && backButton && pickerContainer) {
    let pickerMounted = false;
    let switching = false;

    // Podtytuł mówi o wyborze wydziału z kafelków - przy pickerze zbędny (ten ma własny
    // nagłówek "Wybierz swoją uczelnię:").
    const tilesView: HTMLElement[] = [container, showAllButton, ...(tagline ? [tagline] : [])];
    const pickerView: HTMLElement[] = [pickerContainer, backButton];

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // Płynna zamiana: stary widok wygasa (w górę), nowy pojawia się (od dołu) - ten sam ruch co
    // mumin-body-fade-in/out w landing3.html, tylko na samych podmienianych elementach (nagłówek
    // strony zostaje w miejscu). Web Animations zamiast View Transitions - te drugie animowałyby
    // tu cały root (ze slide'em z landing3.html, łącznie z nagłówkiem serwisu).
    // fill:"forwards" - wygaszony widok ma zostać niewidoczny, nawet gdy lista uczelni ładuje się
    // dłużej niż samo wygaszanie; animacje są potem jawnie zdejmowane (clearFade).
    const clearFade = (elements: HTMLElement[]): void =>
        elements.forEach(el => el.getAnimations().forEach(a => a.cancel()));
    const fade = (elements: HTMLElement[], keyframes: Keyframe[], duration: number): Promise<unknown> =>
        Promise.all(elements.map(el => el.animate(keyframes, { duration, easing: "ease", fill: "forwards" }).finished));

    const switchView = async (showPicker: boolean): Promise<void> => {
        if (switching) return;
        switching = true;
        const [from, to] = showPicker ? [tilesView, pickerView] : [pickerView, tilesView];

        // Lista uczelni ładuje się (jeszcze w ukrytym kontenerze) RÓWNOLEGLE z wygaszaniem
        // kafelków - picker pojawia się od razu gotowy, bez mignięcia "Ładowanie...".
        const mounting = showPicker && !pickerMounted ? mountUniversityPicker(pickerContainer, null) : null;
        pickerMounted ||= showPicker;
        await Promise.all([
            reducedMotion ? null : fade(from, [{ opacity: 1, transform: "none" }, { opacity: 0, transform: "translateY(-8px)" }], 150),
            mounting,
        ]);
        from.forEach(el => { el.hidden = true; });
        clearFade(from);
        to.forEach(el => { el.hidden = false; });

        if (!reducedMotion) {
            await fade(to, [{ opacity: 0, transform: "translateY(8px)" }, { opacity: 1, transform: "none" }], 250);
            clearFade(to);
        }
        switching = false;
    };

    showAllButton.addEventListener("click", () => switchView(true));
    backButton.addEventListener("click", () => switchView(false));
}
